import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  offers: [],
  storeOffer: {},
  updateOffer: {},
  deleteOffer: {},
};

const offersSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    loadOffersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadOffersSuccess(state, action: any) {
      state.loading = false;
      state.error = null;

      state.offers = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadOffersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadNonPaginatedOfferRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadNonPaginatedOfferSuccess(
      state,
      action: PayloadAction<{ result: any }>
    ) {
      state.loading = false;
      state.error = null;
      state.nonPaginateOffer = action.payload.result;
    },
    loadNonPaginatedOfferFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateOfferRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateOfferSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateOffer = action.payload;
    },
    updateOfferFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteOfferRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteOfferSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteOffer = action.payload;
    },
    deleteOfferFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeOfferRequested(
      state,
      action: PayloadAction<{
        id: any;
        name: string;
        price: any;
        discount: any;
        startDate: any;
        endDate: any;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    storeOfferSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeOffer = action.payload;
    },
    storeOfferFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeAssignProductRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeAssignProductSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeAssignProduct = action.payload;
    },
    storeAssignProductFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    removeOfferRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    removeOfferSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.removeOffer = action.payload;
    },
    removeOfferFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadOffersRequested,
  loadOffersSuccess,
  loadOffersFail,
  storeOfferRequested,
  storeOfferSuccess,
  storeOfferFail,
  loadNonPaginatedOfferRequested,
  loadNonPaginatedOfferSuccess,
  loadNonPaginatedOfferFail,
  updateOfferRequested,
  updateOfferSuccess,
  updateOfferFail,
  deleteOfferRequested,
  deleteOfferSuccess,
  deleteOfferFail,
  storeAssignProductFail,
  storeAssignProductRequested,
  storeAssignProductSuccess,
  removeOfferRequested,
  removeOfferSuccess,
  removeOfferFail,
} = offersSlice.actions;

export default offersSlice.reducer;
